import { exists } from '@/api'

export interface AuthorityDetailAuthority {
  authorityNo: string
  tag: string
  detailedData: string
  revision: number
}

export function AuthorityDetailAuthorityFromJSON(
  json: any
): AuthorityDetailAuthority {
  return {
    authorityNo: exists(json, 'authority_no') ? json.authority_no : '',
    tag: exists(json, 'tag') ? json.tag : '',
    detailedData: exists(json, 'detailed_data') ? json.detailed_data : '',
    revision: exists(json, 'revision') ? json.revision : 0
  }
}
